module.exports = __webpack_public_path__ + "img/cropped-ralph-ravi-kayden-9VYBHWEoFfU-unsplash-large.c008e6bf.webp";